import { Stack, TextField } from "@mui/material";
import type { FC, KeyboardEvent } from "react";
import { useState } from "react";

interface Props {
  readonly label: string;
  readonly onSubmit: (text: string) => void;
}

const NoteSimpleInput: FC<Props> = (props) => {
  const [text, setText] = useState("");

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Enter") {
      setText("");
      props.onSubmit(text);
    }
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        justifyContent: "space-between",
      }}
    >
      <TextField
        label={props.label}
        value={text}
        onKeyPress={handleKeyPress}
        onChange={(e) => setText(e.target.value)}
        style={{ flexGrow: 1 }}
      />
    </Stack>
  );
};

export default NoteSimpleInput;
